import { Box, FormField, Label } from '@zillow/constellation-10';
import { LoadingImage } from '@zg-rentals/loading-components';

const FieldSkeleton = ({ label, required, optional }: { label: string; required?: boolean; optional?: boolean }) => (
  <FormField
    required={required}
    optional={optional}
    label={<Label>{label}</Label>}
    control={<LoadingImage isLoading={true} loadingWidth="100%" loadingHeight="40px" />}
  />
);

const SkeletonPropertyDetailsModal = (): JSX.Element => (
  <Box
    data-testid="property-details-skeleton"
    css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}
    aria-busy="true"
    aria-live="polite"
  >
    <FieldSkeleton label="Beds" required />
    <FieldSkeleton label="Baths" required />
    <FieldSkeleton label="Size" optional />
  </Box>
);

export default SkeletonPropertyDetailsModal;
